import _slicedToArray from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function fromEntries(entries) {
  var o = {};
  Object.keys(entries).forEach(function (key) {
    var _entries$key = _slicedToArray(entries[key], 2),
        k = _entries$key[0],
        v = _entries$key[1];

    o[k] = v;
  });
  return o;
}

export { fromEntries };